import { apiListAll, apiPatch } from '@/core/api/resources'
import type { WriteIdentity } from '@/core/api/http'
import { participantSignature } from '@/core/data/dokumente'
import { NACHWEIS_DOC_PREFIX } from '@/core/lib/nachweisDocName'
import { formatDatum } from '@/core/lib/dates'
import type { DokumentCoreRead } from '../api/resources'

export type NachweisDocRow = {
  id: string
  bucketAddress: string
  sitzungId: string
  createdAt: string
  signed: boolean
}

export type NachweisItem = {
  id: string
  datum: string
  signed: boolean
  bucketAddress: string | null
}

function mapNachweisDocRow(row: DokumentCoreRead): NachweisDocRow {
  const sitzung = row.sitzung?.[0]
  return {
    id: row.id,
    bucketAddress: row.bucket_address ?? '',
    sitzungId: sitzung?.id ?? '',
    createdAt: row.created_at,
    signed: participantSignature(row.signatur ?? []) !== undefined,
  }
}

function mapNachweisRow(row: DokumentCoreRead): NachweisItem {
  const sitzung = row.sitzung?.[0]
  return {
    id: row.id,
    datum: formatDatum(sitzung?.datum ?? ''),
    signed: participantSignature(row.signatur ?? []) !== undefined,
    bucketAddress: row.bucket_address,
  }
}

function fetchNachweisRows(coachingId: string): Promise<DokumentCoreRead[]> {
  return apiListAll('/dokumente', {
    coaching_id: coachingId,
    name__prefix: NACHWEIS_DOC_PREFIX,
    include: ['signatur', 'sitzung'],
  })
}

export async function listNachweisDocs(coachingId: string): Promise<NachweisDocRow[]> {
  return (await fetchNachweisRows(coachingId)).map(mapNachweisDocRow)
}

export async function listNachweisItems(coachingId: string): Promise<NachweisItem[]> {
  return (await fetchNachweisRows(coachingId)).map(mapNachweisRow)
}

export async function publishNachweis(dokumentId: string, identity?: WriteIdentity): Promise<void> {
  await apiPatch('/azav/dokumente/{id}', { id: dokumentId }, { teilnehmer_sichtbar: true }, identity)
}
